import * as React from "react";
import TextStyleMenuItem from "../menuitems/TextStyleMenuItem";
import StructureMenuItem from "../menuitems/StructureMenuItem";
import SpacerMenuItem from "../menuitems/SpacerMenuItem";
import ShapeMenuItem from "../menuitems/ShapeMenuItem";
import MergeMenuItem from "../menuitems/MergeMenuItem";
import ImageMenuItem from "../menuitems/ImageMenuItem";
import IconMenuItem from "../menuitems/IconMenuItem";
import BorderPresetMenuItem from "../menuitems/BorderPresetMenuItem";
import BorderWeightMenuItem from "../menuitems/BorderWeightMenuItem";
import BorderTypeMenuItem from "../menuitems/BorderTypeMenuItem";
import BorderColorMenuItem from "../menuitems/BorderColorMenuItem";
import PropTypes from "prop-types";
import BackgroundColorMenuItem from "../menuitems/BackgroundColorMenuItem";
import SpacerBackgroundColorMenuItem from "../menuitems/SpacerBackgroundColorMenuItem";
import TableBordersMenuItem from "../menuitems/TableBordersMenuItem";
import SelectionBordersMenuItem from "../menuitems/SelectionBordersMenuItem";
import { useSelector } from "react-redux";

const HorizontalContextMenuRightSide = ({ selectedTab, isBorderMenu, isSubMenuSelectedByKeyboard, selection }) => {
  // Suppress style menu if border menu is active
  const showStyleMenu = selectedTab === "style" && !isBorderMenu;
  // Use TableStyleMenuItem for table selection, TextStyleMenuItem for single cell/other selections
  const isTableSelected = selection?.table === true;

  const structure = useSelector((state) => state.gridd.present.structure);
  const isSpacerSelected = (sel, str) => {
    if (sel.columns.length > 0) {
      const col = str.columns[sel.columns[0]];
      return col?.length > 0 ? col[0] === "s" : false;
    }
    if (sel.rows.length > 0) {
      const row = str.rows[sel.rows[0]];
      return row?.length > 0 ? row[0] === "s" : false;
    }
    return false;
  };

  const spacerSelected = isSpacerSelected(selection, structure);

  return (
    <div
      id="context_menu_right_div"
      style={{
        background: "white",
        minWidth: 230,
        padding: 8,
      }}
    >
      {showStyleMenu && <TextStyleMenuItem isKeyboardSelected={isSubMenuSelectedByKeyboard} />}
      {selectedTab === "borders" && isTableSelected && <TableBordersMenuItem />}
      {selectedTab === "borders" && !isTableSelected && <SelectionBordersMenuItem />}
      {selectedTab === "background" && spacerSelected && (
        <SpacerBackgroundColorMenuItem isKeyboardSelected={isSubMenuSelectedByKeyboard} />
      )}
      {selectedTab === "background" && !spacerSelected && (
        <BackgroundColorMenuItem isKeyboardSelected={isSubMenuSelectedByKeyboard} />
      )}
      {selectedTab === "structure" && <StructureMenuItem />}
      {selectedTab === "spacer" && <SpacerMenuItem />}
      {selectedTab === "shape" && <ShapeMenuItem isKeyboardSelected={isSubMenuSelectedByKeyboard} />}
      {selectedTab === "merge" && <MergeMenuItem isKeyboardSelected={isSubMenuSelectedByKeyboard} />}
      {selectedTab === "image" && <ImageMenuItem isKeyboardSelected={isSubMenuSelectedByKeyboard} />}
      {selectedTab === "icon" && <IconMenuItem isKeyboardSelected={isSubMenuSelectedByKeyboard} />}
      {isBorderMenu && (
        <>
          {selectedTab === "preset" && <BorderPresetMenuItem />}
          {selectedTab === "weight" && <BorderWeightMenuItem />}
          {selectedTab === "type" && <BorderTypeMenuItem />}
          {selectedTab === "color" && <BorderColorMenuItem />}
        </>
      )}
    </div>
  );
};

HorizontalContextMenuRightSide.propTypes = {
  selectedTab: PropTypes.string,
  isBorderMenu: PropTypes.bool,
  isSubMenuSelectedByKeyboard: PropTypes.bool,
  selection: PropTypes.object,
};

export default HorizontalContextMenuRightSide;
